// 门户网站-- 路由
export default [
  {
    path: "/",
    name: "home",
    component: resolve => require(["@/views/officalweb/home/index"], resolve),
    meta: {
      name: "首页"
    }
  },
  {
    path: "/workDynamics",
    name: "workDynamics",
    component: resolve =>
      require(["@/views/officalweb/workDynamics/index"], resolve),
    meta: {
      name: "工作动态",
      needLogin: true
    }
  },
  {
    path: "/workDynamicsDdtail",
    name: "workDynamicsDdtail",
    component: resolve =>
      require(["@/views/officalweb/workDynamics/workDynamicsDdtail"], resolve),
    meta: {
      name: "工作动态详情",
      needLogin: true
    }
  },
  {
    path: "/standardSolicitation",
    name: "standardSolicitation",
    component: resolve =>
      require(["@/views/officalweb/standardSolicitation/index"], resolve),
    meta: {
      name: "标准征求意见",
      needLogin: true
    }
  },
  {
    path: "/standardSolicitationDetail",
    name: "standardSolicitationDetail",
    component: resolve =>
      require([
        "@/views/officalweb/standardSolicitation/standardSolicitationDetail"
      ], resolve),
    meta: {
      name: "标准征求意见详情",
      needLogin: true
    }
  },
  {
    path: "/standardQuery",
    name: "standardQuery",
    component: resolve =>
      require(["@/views/officalweb/standardQuery/index"], resolve),
    meta: {
      name: "标准查询",
      needLogin: true
    }
  },
  {
    path: "/testEvaluation",
    name: "testEvaluation",
    component: resolve =>
      require(["@/views/officalweb/testEvaluation/index"], resolve),
    meta: {
      name: "产业服务",
      needLogin: true
    }
  },
  {
    path: "/testEvaluationDetail",
    name: "testEvaluationDetail",
    component: resolve =>
      require([
        "@/views/officalweb/testEvaluation/testEvaluationDetail"
      ], resolve),
    meta: {
      name: "产业服务详情",
      needLogin: true
    }
  },
  {
    path: "/documentCenter",
    name: "documentCenter",
    component: resolve =>
      require(["@/views/officalweb/documentCenter/index"], resolve),
    meta: {
      name: "文档中心",
      needLogin: true
    }
  },
  {
    path: "/docCenterDetail",
    name: "docCenterDetail",
    component: resolve =>
      require(["@/views/officalweb/documentCenter/docCenterDetail"], resolve),
    meta: {
      name: "文档中心详情",
      needLogin: true
    }
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: resolve =>
      require(["@/views/officalweb/aboutus/index"], resolve),
    meta: {
      name: "关于我们",
      needLogin: false
    }
  },
  {
    path: "/searchPage",
    name: "searchPage",
    component: resolve =>
      require(["@/views/officalweb/searchPage/index"], resolve),
    meta: {
      name: "搜索页面",
      needLogin: true
    }
  },
  {
    path: "/searchPageDetail",
    name: "searchPageDetail",
    component: resolve =>
      require(["@/views/officalweb/searchPage/searchPageDetail"], resolve),
    meta: {
      name: "搜索详情",
      needLogin: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: resolve => require(["@/views/officalweb/login/index"], resolve),
    meta: {
      name: "登录",
      needLogin: true
    }
  },
  {
    path: "/regist",
    name: "regist",
    component: resolve => require(["@/views/officalweb/regist/index"], resolve),
    meta: {
      name: "注册",
      needLogin: true
    }
  },
  {
    path: "/file",
    name: "file",
    component: resolve => require(["@/views/officalweb/regist/file"], resolve),
    meta: {
      name: "资料",
      needLogin: true
    }
  },
  {
    path: "/registInfo",
    name: "registInfo",
    component: resolve => require(["@/views/officalweb/regist/info"], resolve),
    meta: {
      name: "注册",
      needLogin: true
    }
  },
  {
    path: "/forgetpassword",
    name: "forgetpassword",
    component: resolve =>
      require(["@/views/officalweb/forgetpassword/index"], resolve),
    meta: {
      name: "忘记密码",
      needLogin: true
    }
  },
  {
    path: "/messageCenter",
    name: "messageCenter",
    component: resolve =>
      require(["@/views/officalweb/messageCenter/index"], resolve),
    meta: {
      name: "消息中心",
      needLogin: true
    }
  },
  {
    path: "/personalCenter/accountInfo",
    name: "personalCenter_accountInfo",
    component: resolve =>
      require(["@/views/officalweb/personalCenter/index"], resolve),
    meta: {
      name: "消息中心",
      needLogin: true
    },
    children: [
      {
        path: "/personalCenter/accountInfo",
        name: "personalCenter_accountInfo",
        component: resolve =>
          require(["@/views/officalweb/personalCenter/accountInfo"], resolve),
        meta: {
          name: "账户信息",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/repassword",
        name: "personalCenter_repassword",
        component: resolve =>
          require(["@/views/officalweb/personalCenter/repassword"], resolve),
        meta: {
          name: "修改密码",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/feedback",
        name: "personalCenter_feedback",
        component: resolve =>
          require(["@/views/officalweb/personalCenter/feedback"], resolve),
        meta: {
          name: "问题反馈",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/projectApplication",
        name: "personalCenter_projectApplicationk",
        component: resolve =>
          require([
            "@/views/officalweb/personalCenter/projectApplication"
          ], resolve),
        meta: {
          name: "立项申请",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/standarDevelopment",
        name: "personalCenter_standarDevelopment",
        component: resolve =>
          require([
            "@/views/officalweb/personalCenter/standarDevelopment"
          ], resolve),
        meta: {
          name: "标准研制",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/applicationGloablExpert",
        name: "personalCenter_applicationGloablExpert",
        component: resolve =>
          require([
            "@/views/officalweb/personalCenter/applicationGloablExpert"
          ], resolve),
        meta: {
          name: "申请国际专家",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/applyApproval",
        name: "personalCenter_applyApproval",
        component: resolve =>
          require(["@/views/officalweb/personalCenter/applyApproval"], resolve),
        meta: {
          name: "立项申请",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/applyNews",
        name: "personalCenter_applyNews",
        component: resolve =>
          require(["@/views/officalweb/personalCenter/applyNews"], resolve),
        meta: {
          name: "新闻申请",
          needLogin: true
        }
      },
      {
        path: "/personalCenter/vdeedback",
        name: "personalCenter_vdeedback",
        component: resolve =>
          require(["@/views/officalweb/personalCenter/vdeedback"], resolve),
        meta: {
          name: "查看意见反馈",
          needLogin: true
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/offical.js